import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { RootState, Dispatch } from 'store';
import Launcher from './components/Launcher';
import ChatBox from './components/ChatBox';
import MessageBubble from './components/DefaultMessageBubble';
import setTitlebar from 'helpers/unreadTitlebar';

const mapState = (state: RootState) => ({
  isChatInitialized: state.chat.isInitialized,
  messages: state.chat.messages,
  unread: state.chat.unread,
  defaultRoomMessage: state.site.defaultRoomMessage,
});

const mapDispatch = (dispatch: Dispatch) => ({
  getMessages: dispatch.chat.getMessages,
});

type StateProps = ReturnType<typeof mapState>;
type DispatchProps = ReturnType<typeof mapDispatch>;
type ReduxProps = StateProps & DispatchProps;

function ChatRoom({
  defaultRoomMessage,
  messages,
  getMessages,
  isChatInitialized,
  unread,
}: ReduxProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const [popupMessage, setPopupMessage] = useState('');

  useEffect(() => {
    getMessages(undefined);
  }, [getMessages]);

  useEffect(() => {
    let timeout: number;

    if (
      unread !== 1 ||
      messages.length !== 1 ||
      messages[0]?.body !== defaultRoomMessage
    ) {
      setUnreadCount(messages.length);
      return;
    }

    timeout = window.setTimeout(() => {
      setPopupMessage(defaultRoomMessage);
      setUnreadCount(unread);
    }, 2000);

    return () => {
      clearTimeout(timeout);
    };
  }, [unread, messages, defaultRoomMessage]);

  useEffect(() => {
    setTitlebar(unread);
  }, [unread]);

  useEffect(() => {
    if (
      !isLoaded &&
      isChatInitialized &&
      ((messages.length === 1 && messages[0].body !== defaultRoomMessage) ||
        messages.length > 1)
    ) {
      // setIsOpen(true);
      setIsLoaded(true);
    }
  }, [isChatInitialized, messages, isLoaded, defaultRoomMessage]);

  if (!isChatInitialized) {
    return null;
  }

  return (
    <>
      {isOpen ? <ChatBox /> : null}
      {popupMessage ? (
        <MessageBubble
          message={defaultRoomMessage}
          onClick={() => {
            setIsOpen(true);
            setPopupMessage('');
          }}
        />
      ) : null}
      <Launcher
        unreadCount={unreadCount}
        onClick={() => {
          setIsOpen(!isOpen);
          setPopupMessage('');
        }}
        isOpen={isOpen}
      />
    </>
  );
}

export default connect(mapState, mapDispatch)(ChatRoom);
